<template>
  <div id="resetPassword" class="login-container">
    <loginSidebar />
    <div class="login-right">
      <div class="login-form" v-if="ssoUser">
        <h3>SSO Login Required</h3>
        <p>{{ ssoMessage }}</p>
      </div>
      <div class="login-form" v-if="!ssoUser && !passwordChanged && invalidToken">
        <p class="form-group">
          It looks like you clicked on an invalid password reset link. Please try again.
        </p>
        <div class="form-group">
          <button type="button" class="btn primary" v-on:click="goToForgotPassword()">
            Forgot password?
          </button>
        </div>
      </div>
      <div class="login-form" v-if="!ssoUser && !passwordChanged && !invalidToken">
        <VeeForm ref="form">
          <form>
            <div class="form-group">
              <h3>Set New Password</h3>
              <p>Enter your new password below</p>
            </div>
            <div class="form-group">
              <label>New Password</label>
              <div class="position-relative">
                <VeeField name="Password" rules="required" v-model="password" v-slot="{ field, errors }">
                  <input
                    :type="passwordFieldType"
                    name="password"
                    class="form-control"
                    @input="valueChange()"
                    v-bind="field"
                  />
                  <span
                    :class="[isActive ? 'invalid' : '']"
                    :style="[isActive ? {'display': 'block'} : {'display': 'none'}]"
                    v-if="errors[0]"
                  >{{ errors[0].replace("The ", "" )}}</span>
                </VeeField>
                  <a
                    class="forgot-show"
                    @click="switchVisibility"
                    v-if="passwordFieldType === 'password'"
                  >Show</a>
                  <a
                    class="forgot-show"
                    @click="switchVisibility"
                    v-if="passwordFieldType === 'text'"
                  >Hide</a>
              </div>
            </div>
            <div class="form-group pt-1 mb-3">
              <button type="button" class="btn primary" v-on:click="resetPassword()">Set New Password</button>
            </div>
            <div class="text-center">
              <a v-on:click="returnToLogin()" class="forgot-link">Back to Log In</a>
            </div>
          </form>
        </VeeForm>
      </div>
      <div v-if="!ssoUser && passwordChanged" class="login-form">
        <h4>Password has been changed</h4>
          <p class="form-group">
            Your password has been successfully changed. You can now login with your new password.
          </p>
          <div class="form-group">
            <button type="button" class="btn primary" v-on:click="returnToLogin()">
              Login
            </button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>

import api from "../services/api";
import loginSidebar from "../components/loginSidebar.vue";
import { utilFunctionService } from "@/utils/utils.service";
import { commonConfig } from "@/utils/commonConfig";

export default {
  name: "resetPassword",
  components: {
    loginSidebar
  },
  data() {
    return {
      password : '',
      isActive: false,
      invalidCred: false,
      passwordFieldType: "password",
      invalidToken: '',
      passwordChanged: false,
      token: '',
      ssoUser: false,
      ssoMessage: commonConfig.appMessages.ssoLoginRequired
    };
  },
  methods: {
    valueChange() {
      this.invalidCred = false;
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    resetPassword() {
     this.$refs.form.validate().then(({ valid: success }) => {
          this.isActive = true;
          if (!success) {
            return;
          } else {
            this.isActive = false;
            const _fb = new FormData();
            _fb.append("reset_password[token]", this.token);
            _fb.append("reset_password[password]", this.password);
            api
              .resetPassword(_fb)
              .then(() => {
                this.passwordChanged = true
              }).catch(() => {})
        }
      });
    },
    returnToLogin() {
      this.$router.replace({ name: "login" });
    },
    goToForgotPassword() {
      this.$router.replace({ name: "forgot password" });
    }
  },
  async created(){
    if (utilFunctionService.getLocalStorageService('sso_authenticated')) {
      this.ssoUser = true;
      return;
    }
    this.token = this.$route.params.token
      api
        .verifyToken(this.token)
        .then((res) => {
          if (res.data.is_valid)
            this.invalidToken = false
          else
           this.invalidToken = true
        })
        .catch(() => {
          this.invalidToken = true
        });
    }
};
</script>
